/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查看我的电子钱包信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.EWalletInfoDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/wallet`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
